/* jshint node:true */
'use strict';

// Date comparison taken from
// http://stackoverflow.com/questions/492994/compare-two-dates-with-javascript

const moment = require('moment-timezone');
const selectn = require('selectn');

// date time formatting related settings
const dateTime = {
    'dateFormats': {
        'time1': '',
        'date1': 'D MMM, YYYY',
        'date2': 'D/M/YYYY',
        'date3': 'DD/MM/YYYY',
        'date4': 'DDMMYYYY',
        'date5': 'Do MMMM YYYY',
        'date6': 'dddd, Do MMMM YYYY',
        'date7': 'ddd, D MMM YYYY',
        'date8': 'D/M',
        'date9': 'ddd',
        'date10': 'dddd, MMMM Do',
        'date11': 'MMMM YYYY',
        'date12': 'YYYYMMDD',
        'date13': 'MMMM Do, YYYY',
        'dateTime1': 'h:mm A, MMMM D, YYYY',
        'dateTime2': 'h:mm A'
    },
    'dayNamesLong': 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday'.split(' '),
    'dayNamesMedium': 'Sun Mon Tue Wed Thu Fri Sat'.split(' '),
    'dayNamesShort': 'Su Mo Tu We Th Fr Sa'.split(' '),
    'monthNamesLong': 'January February March April May June July August September October November December'.split(' '),
    'monthNamesShort': 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ')
};

module.exports = {

    dateToKey: function (oDate) {
        return this.dateFormat(oDate, 'date12')
    },

    paramToDate: function (sParam) {

        if (typeof sParam === 'undefined' || sParam === null || !sParam) {
            return null
        }
        var iYear = sParam.substr(0, 4)
        var iMonth = sParam.substr(4, 2)
        var iDay = sParam.substr(6, 2)

        return moment(iYear + '-' + iMonth + '-' + iDay).toDate();

    },

    dateDayNamesMedium: function () {
        return dateTime.dayNamesMedium
    },

    dateFormat: function (ISODate, dateFormat, showTimezone) {

        if (ISODate === undefined) {
            return ISODate
        }

        if (dateFormat === undefined) {
            dateFormat = 'date6'
        }

        showTimezone = showTimezone || false;

        var formatsMap = dateTime.dateFormats;
        var utcMoment = moment(ISODate);//, moment.ISO_8601
        var localMoment = moment(utcMoment.utc().toDate());

        dateFormat = formatsMap[dateFormat];
        var dateString = localMoment.format(dateFormat);
        //console.log(localMoment.format('z'))
        //window.moment().tz(window.jstz.determine().name()).format('z')
        //if ($(element).hasClass('time') && showTimezone === 'true') {
        //    var currentTimezone = espn_ui.Helpers.timezones.getCurrentTimezone()
        //    dateString += ' ' + espn_ui.Behaviors.date_timezone.replace(currentTimezone)
        //}

        return dateString
    },


    /**
     * Converts the date in d to a date-object using moment-timezone
     * @param  {String/object} d date in string/Object
     * @return {Object}          date-object
     */
    dateToObject: function (d) {
        return moment(d).toDate()
    },

    /**
     * Compare two dates (could be of any type supported by the convert
     * function above) and returns:
     *  -1 : if a < b
     *   0 : if a = b
     *   1 : if a > b
     * NaN : if a or b is an illegal date
     * NOTE: The code inside isFinite does an assignment (=).
     *
     * @param  {String/object} a date in string/Object
     * @param  {String/object} b date in string/Object
     * @return {Number}        as described above
     **/
    dateCompare: function (a, b) {
        return (
            isFinite(a = this.dateToObject(a).valueOf()) &&
            isFinite(b = this.dateToObject(b).valueOf()) ?
            (a > b) - (a < b) :
                NaN
        )
    },

    /**
     * Checks if date in d is between dates in start and end.
     * Returns a boolean or NaN:
     *    true  : if d is between start and end (inclusive)
     *    false : if d is before start or after end
     *    NaN   : if one or more of the dates is illegal.
     * NOTE: The code inside isFinite does an assignment (=).
     *
     * @param {String/object} d date in string/Object
     * @param {String/Object} start startdate
     * @param {String/Object} end startdate
     * @return {Boolean/NaN}  As described above
     **/
    dateInRange: function (d, start, end) {
        return (
            isFinite(d = this.dateToObject(d).valueOf()) &&
            isFinite(start = this.dateToObject(start).valueOf()) &&
            isFinite(end = this.dateToObject(end).valueOf()) ?
            start <= d && d <= end :
                NaN
        )
    },

    /**
     * Convert date/time as per the passed options of timezone and formatting
     * @param  {String} d date  String in ISO 8601 format
     * @param  {Object} options date formatting options
     * @return {String}         formatted time as per the options
     */
    convertDateTime: function (d, options) {
        // default return type
        let displayTime = ''

        /**
         * default formatting options
         * UTC as time zone - 'Europe/London'
         * 24HR time format - HH:mm z
         */
        let timeZone = 'Europe/London'
        let timeFormat = 'h:mm A'
        // Override default options if options input has valid properties
        if (typeof selectn('timeZone', options) !== 'undefined') {
            timeZone = options.timeZone
        }

        if (typeof selectn('timeFormat', options) !== 'undefined') {
            timeFormat = options.timeFormat
        }
        // Convert to moment object
        let startTime = moment(d)
        // Format the date only if valid
        if (startTime.isValid() === true) {
            displayTime = startTime.tz(timeZone).format(timeFormat)
            //console.log('original, convertDateTime', d, displayTime)
        }
        return displayTime
    },

    /**
     * Convert date string from v1/listings API to the valid ISO string
     * @param  {String} str A date string to convert
     * @return {String} ISO 8601 date string
     */
    toISOString: function (str = '') {
        return str.replace(/GMT$/, 'Z')
                  .replace(/EST$/, '-05:00')
                  .replace(/EDT$/, '-04:00');
    }
}



// WEBPACK FOOTER //
// ./app/lib/format/dateFormat.js